/** @jsxImportSource @emotion/react */

import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer,
  EuiTitle,
} from "@inscopix/ideas-eui";
import "ag-grid-enterprise";
import { ParametersViewer } from "./ParametersViewer";
import { ResultsViewer } from "./ResultsViewer";
import { ToolSpecV3 } from "types/json-schemas/ToolSpecV3";

export const ToolSpecViewer = ({ toolSpec }: { toolSpec: ToolSpecV3 }) => {
  const params = toolSpec.params;
  const results = toolSpec.results;

  return (
    <EuiFlexGroup direction="column" gutterSize="s">
      <EuiFlexItem grow={false} css={{ height: 40 }}>
        <EuiTitle size="s">
          <h3>Parameters</h3>
        </EuiTitle>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ParametersViewer rowData={params} />
      </EuiFlexItem>
      <EuiSpacer size="xs" />
      <EuiFlexItem grow={false} css={{ height: 40 }}>
        <EuiFlexGroup alignItems="center">
          <EuiFlexItem grow={false}>
            <EuiTitle size="s">
              <h3>Outputs</h3>
            </EuiTitle>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ResultsViewer rowData={results} />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
